import React from 'react';
import Badge, { badgeColors } from './Badge';
import type { BadgeSize } from './Badge';
import { formatPlanName } from '../../utils/formatters';

interface PlanBadgeProps {
  planId: string | undefined;
  size?: BadgeSize;
}

const planColorMap: Record<string, string> = {
  institutional: badgeColors.warning,
  advisor: badgeColors.info,
  basic: badgeColors.success,
};

// Plan is a label, not a status — render as a quiet chip.
const PlanBadge: React.FC<PlanBadgeProps> = ({ planId, size = 'xs' }) => {
  const colorClass = planColorMap[planId || ''] || badgeColors.neutral;
  return (
    <Badge colorClass={colorClass} size={size} variant="chip">
      {formatPlanName(planId)}
    </Badge>
  );
};

export default PlanBadge;
